import React from 'react';
import styled from 'styled-components';
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 320px;
`;

const ModalButton = styled.button`
  background-color: #2089ac;
  color: white;
  padding: 10px 20px;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 93%;

  &:hover {
    background-color: #1a6f8b;
  }
`;

const Modal = ({ onClose, onWhatsAppClick, onGmailClick }) => {
  return (
    <ModalOverlay>
      <ModalContent>
        <h3>Choisissez une option</h3>
        <ModalButton onClick={onWhatsAppClick} style={{ backgroundColor: '#25D366' }}>
          <FaWhatsapp size={20} /> Envoyer via WhatsApp
        </ModalButton>
        <ModalButton onClick={onGmailClick} style={{ backgroundColor: '#D44638' }}>
          <FaEnvelope size={20} /> Envoyer via Gmail
        </ModalButton>
        <ModalButton onClick={onClose}>Fermer</ModalButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;
